var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 20C11.1003 20 12.0003 19.1 12.0003 18H8.00027C8.00027 19.1 8.90027 20 10.0003 20ZM16.0003 14V9C16.0003 5.93 14.3703 3.36 11.5003 2.68V2C11.5003 1.17 10.8303 0.5 10.0003 0.5C9.17027 0.5 8.50027 1.17 8.50027 2V2.68C5.64027 3.36 4.00027 5.92 4.00027 9V14L2.00027 16V17H18.0003V16L16.0003 14ZM14.0003 15H6.00027V9C6.00027 6.52 7.51027 4.5 10.0003 4.5C12.4903 4.5 14.0003 6.52 14.0003 9V15ZM5.58027 2.08L4.15027 0.65C1.75027 2.48 0.170273 5.3 0.0302734 8.5H2.03027C2.18027 5.85 3.54027 3.53 5.58027 2.08ZM17.9703 8.5H19.9703C19.8203 5.3 18.2403 2.48 15.8503 0.65L14.4303 2.08C16.4503 3.53 17.8203 5.85 17.9703 8.5Z",
    fill: "#88087B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveNotificationIcon);
export default __webpack_public_path__ + "static/media/active-notification-icon.4d47e2fdbb84c661d8ca60b1b1a487aa.svg";
export { ForwardRef as ReactComponent };